import { cn } from '@/lib/utils'

export interface SkeletonProps {
  readonly className?: string
}

/**
 * Placeholder pulsante para estados de carregamento — dá percepção de velocidade (padrão SaaS) no
 * lugar de um spinner centralizado. Decorativo (`aria-hidden`): o estado de "carregando" deve ser
 * anunciado pelo container (ex.: `aria-busy`) ou por um texto de spinner à parte. Respeita
 * prefers-reduced-motion (sem pulso).
 */
export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'animate-pulse rounded-md bg-background-subtle motion-reduce:animate-none',
        className,
      )}
    />
  )
}
